 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML03_COPYRIGH from '@/components/xhtml/03_Copyrigh'
 import XHTML02_TITLE_PA from '@/components/xhtml/02_Title_Pa'
 import XHTML01_SERIES_P from '@/components/xhtml/01_Series_P'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_PREFACE_ from '@/components/xhtml/05_Preface_'
 import XHTML06_HALF_TIT from '@/components/xhtml/06_Half_Tit'
 import XHTML07_I__M_SO from '@/components/xhtml/07_I__M_SO'
 import XHTML08_POLITICA from '@/components/xhtml/08_POLITICA'
 import XHTML09_IMAGE__S from '@/components/xhtml/09_IMAGE__S'
 import XHTML10_NOTE from '@/components/xhtml/10_Note'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Preface_",
 			"name" : "xhtml/05_Preface_",
 			"component" : XHTML05_PREFACE_
 		},
 		{
 			"path" : "/xhtml/06_Half_Tit",
 			"name" : "xhtml/06_Half_Tit",
 			"component" : XHTML06_HALF_TIT
 		},
 		{
 			"path" : "/xhtml/07_I__M_SO",
 			"name" : "xhtml/07_I__M_SO",
 			"component" : XHTML07_I__M_SO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js